<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Bachelor of Business Administration</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Bachelor of Business Administration</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="bba ptb--100  horizontal--tab">
  <div class="container">
    <div class="row">
      <div class="col">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="department-tab" data-bs-toggle="tab" data-bs-target="#department"
              type="button" role="tab" aria-controls="department" aria-selected="true">About Department</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="eligibility-tab" data-bs-toggle="tab" data-bs-target="#eligibility"
              type="button" role="tab" aria-controls="eligibility" aria-selected="false">Eligibility Criteria</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="duration-tab" data-bs-toggle="tab" data-bs-target="#duration" type="button"
              role="tab" aria-controls="duration" aria-selected="false">Duration</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="opportunities-tab" data-bs-toggle="tab" data-bs-target="#opportunities"
              type="button" role="tab" aria-controls="opportunities" aria-selected="false">Opportunities which await
              you</button>
          </li>
        </ul>
        <div class="tab-content px-3 py-3" id="myTabContent">
          <div class="tab-pane fade show active" id="department" role="tabpanel" aria-labelledby="department-tab">
            <div>
              <p>BBA is the acronym for Bachelor of Business Administration. It is a graduate degree course. It is that
                perfect program for aspirants who want to make it big in the Business Management industry. This degree
                provides with a sound base to cater to the need of higher studies in MBA.</p>
            </div>
          </div>
          <div class="tab-pane fade" id="eligibility" role="tabpanel" aria-labelledby="eligibility-tab">
            <ul class="list-before">
              <li>A candidate from any stream, should have passed 12th Std. Examination
                (H.S.C.10+2) with minimum 40% of marks and Engpsh as a passing subject.</li>
              <li class="text-center"><strong>OR</strong></li>
              <li>Three Years Diploma Course from Board of Technical Education, conducted by Government of Maharashtra
                or its equivalent, after S.S.C. i.e. 10<sup>th</sup> Standard.</li>
              <li class="text-center"><strong>OR</strong></li>
              <li>Two Years Diploma Course in Pharmacy from Board of Technical Education, conducted by Government of
                Maharashtra or its equivalent, after H.S.C. i.e. 12th Standard.</li>
              <li class="text-center"><strong>OR</strong></li>
              <li>Completed MCVC program</li>
            </ul>
          </div>
          <div class="tab-pane fade" id="duration" role="tabpanel" aria-labelledby="duration-tab">
            <h4 class="yellow-color fw-bold">3 years/6 semesters</h4>
            <ul class="list-before mt-3">
              <li><strong>Course curriculum:-</strong> The core subjects taught in this stream include, Finance,
                Marketing, Operation, Human Resource, International Business, Retail, Logistics and Supply Chain,
                Accounting to name a few. Emphasis is laid on management, methodology, research and principles in these
                subjects.</li>
              <li><strong>Avenues to explore after Bachelor of Business Administration:-</strong> Is it a dream for you
                to make it big in the business industry? Do you want to learn the principles of management? Do you
                aspire to be proficient in the attributes of impeccable administration? Business management experts have
                an immensely vital role to play in every business. That first step towards this journey is a course in
                BBA. With the completion of the course immense is for you to look forward to.</li>
            </ul>
          </div>
          <div class="tab-pane fade" id="opportunities" role="tabpanel" aria-labelledby="opportunities-tab">
            <ul class="list-before">
              <li> MBA- Give your career the requisite push with an MBA degree after BBA. It will make sure to take care
                of your career to soaring heights.</li>
              <li> MCM- you can apply for Masters’ of Computer Management, another promising branch.</li>
              <li> Become an entrepreneur</li>
              <li> Prepare for Civil services with a sound foundation of the subjects</li>
              <li> Banking sector with a plethora of jobs opening every year</li>
              <li> Explore the educational sector with a job as a teacher</li>
            </ul>
          </div>
        </div>
        <div class="text-center">
          <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
        </div>
      </div>
    </div>
  </div>
</section>
